export default __webpack_public_path__ + "static/media/neeraj_sir.a3661a46.jpg";